import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    OnInit,
    Output,
    signal,
    ViewEncapsulation,
} from '@angular/core';
import {
    IOnboardingReportParticipant,
    IOnboardingReportParameter,
    IOnboardingReportSummary,
    IOnboardingReportWidgetFilter,
} from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report';
import { FiOnboardingReportDetailsBase } from '../fi-onboarding-report-details-base';
import { isEqual } from '@fi-shared/utils';
import { IReportAvailableItemsByData } from '@fi-shared/fi-report-table-filter/fi-report-filter-base';

@Component({
    selector: 'fi-onboarding-report-participants-widget',
    templateUrl: './fi-onboarding-report-participants-widget.component.html',
    styleUrl: './fi-onboarding-report-participants-widget.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-onboarding-report-participants-widget' },
    standalone: false,
})
export class FiOnboardingReportParticipantsWidgetComponent extends FiOnboardingReportDetailsBase implements OnInit {
    protected onboardingParticipants = signal<IOnboardingReportParticipant[]>([]);
    protected participantsSummary = signal<IOnboardingReportSummary>(undefined);

    private availableUsersFilter: IOnboardingReportWidgetFilter = {};
    private availableItemsByData: IReportAvailableItemsByData = {};

    ngOnInit() {
        super.ngOnInit();
    }

    protected loadReportData() {
        const parameter = this.getReportParameter();
        this.fiOnboardingReportService.getReportData(parameter).then((result) => {
            this.onboardingParticipants.set(result.OnboardingParticipants);
            this.participantsSummary.set(result.ParticipantsSummary);
            this.checkAvailableBusinessUnits();
            this.checkLoadAvailableUsers();
        });
    }
    private getReportParameter(): IOnboardingReportParameter {
        const parameter = this.fiOnboardingReportHelperService.getReportParameter({
            widget: this.widget,
            filter: this.currentFilter,
            loadOnboardingParticipants: true,
            loadParticipantsSummary: true,
        });
        parameter.SearchText = this.searchText;
        return parameter;
    }

    protected checkLoadAvailableUsers() {
        const newAvailableUsersFilter: IOnboardingReportWidgetFilter = {
            OnboardingIds: this.currentFilter.OnboardingIds,
            BusinessUnitIds: this.currentFilter.BusinessUnitIds,
        };
        if (!isEqual(this.availableUsersFilter, newAvailableUsersFilter)) {
            // we should load available users only if Onboardings or Business units selection was changed
            const availableUsersParameter = this.fiOnboardingReportHelperService.getReportParameter({
                widget: this.widget,
                filter: newAvailableUsersFilter,
            });
            this.fiOnboardingReportService
                .getOnboardingUserUnitAccessData(availableUsersParameter)
                .then((accessData) => {
                    this.availableItemsByData = {
                        ...this.availableItemsByData,
                        UserIds: accessData.map((item) => item.UserId),
                    };
                    this.availableItemsByDataChange.emit(this.availableItemsByData);
                });

            this.availableUsersFilter = newAvailableUsersFilter;
        }
    }

    private checkAvailableBusinessUnits() {
        const availableItemsByData =
            this.fiOnboardingReportTableFilterHelperService.getAvailableUnitsAreasBusinessAreas(
                this.availableItems.Onboardings,
                this.currentFilter.OnboardingIds,
                this.currentFilter,
                this.availableItems,
                { hideDeactivatedUnits: true },
            );
        this.availableItemsByData = {
            ...availableItemsByData,
            UserIds: this.availableItemsByData.UserIds,
        };
        this.availableItemsByDataChange.emit(this.availableItemsByData);
    }
}
